/**
 * Thông báo UI dùng chung — alias của TEXT.messages.
 */
import { TEXT } from '../languages';

export const UI_MESSAGES = TEXT.messages;
